/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

// TODO: Refactor

import { useRef, useState, useEffect } from 'react';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  HStack,
  Box,
  Text,
  Icon,
  Divider,
  Select,
  FormControl,
  Input,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  VStack,
  Stack,
} from '@chakra-ui/react';

import { ReactComponent as FiltersIcon } from '../../../assets/icons/filters.svg';
import { ReactComponent as AdvancedFilter } from '../../../assets/icons/advanced-filter.svg';
import { useSearchParams } from 'react-router-dom';
import {
  useGetAllActiveFormsQuery,
  useGetAllFormTemplatesQuery,
  useGetAllPhasesQuery,
  useGetAllProjectsQuery,
  useGetAllRolesQuery,
  useGetTeamMembersQuery,
} from '../../../services';
import { FiltersOperation, FormFieldTypes, TaskFilters } from '../../../models';
import { useTypedSelector } from '../../../hooks';
import { MultiSelect, Option } from 'chakra-multiselect';
import {
  convertTitleCaseToConditionsEnum,
  getConditionOperator,
} from '../../projects/utils';
import { CenteredSpinner } from '../../../components';

export const TaskFiltersDrawer = ({
  isOpen,
  onClose,
  filters,
  setFilters,
  saveFilters,
}: {
  isOpen: boolean;
  onClose: (filterValues?: any) => void;
  filters: TaskFilters;
  setFilters: any;
  saveFilters: any;
}) => {
  const btnRef = useRef<HTMLElement>(null);
  const [componentScopeFilters, setComponentScopeFilters] =
    useState<TaskFilters>(filters);

  const { userDetails } = useTypedSelector(state => state.auth);

  const { data: projectsData, status: projectsStatus } = useGetAllProjectsQuery(
    { page: 0, size: 1000 }
  );

  const { data: rolesData, status: rolesStatus } = useGetAllRolesQuery(
    {
      page: 0,
      size: 1000,
      basicInfoId: Number(userDetails?.companyBasicInfo.id),
    },
    {
      skip: !userDetails,
    }
  );

  const { data: usersData, status: usersStatus } = useGetTeamMembersQuery(
    {
      page: 0,
      size: 10000,
      companyId: Number(userDetails?.companyBasicInfo.id),
    },
    {
      skip: !userDetails,
    }
  );

  const { data: formsData, status: formsStatus } = useGetAllActiveFormsQuery({
    phaseIds: undefined,
  });

  const { data: phasesData, status: phasesStatus } = useGetAllPhasesQuery(
    {
      page: 0,
      size: 1000,
      projectId: (componentScopeFilters?.projectId as number) ?? 0,
    },
    { skip: !componentScopeFilters?.projectId }
  );

  useEffect(() => {
    if (!componentScopeFilters?.forms) {
      setComponentScopeFilters({ ...componentScopeFilters, forms: [] });
    }
  }, [componentScopeFilters]);

  const setFieldValue = (
    formId: number,
    fieldId: number,
    answer?: string,
    operator?: FiltersOperation
  ) => {
    let copyOfFormsValues = componentScopeFilters?.forms
      ? componentScopeFilters.forms.map(form => ({
          ...form,
          fields: [...form.fields],
        }))
      : [];
    let targetForm = copyOfFormsValues?.find(f => f.id === formId);
    let targetFormIndex = copyOfFormsValues?.findIndex(f => f.id === formId);

    if (!targetForm && targetFormIndex === -1) {
      copyOfFormsValues[copyOfFormsValues.length] = {
        id: formId,
        fields: [
          {
            id: fieldId,
            answer,
            operator,
          },
        ],
      };
      setComponentScopeFilters({
        ...componentScopeFilters,
        forms: copyOfFormsValues,
      });
      return;
    }

    const targetFieldIndex = targetForm?.fields.findIndex(
      f => f.id === fieldId
    );

    if (targetFieldIndex === -1) {
      targetForm.fields.push({
        id: fieldId,
        answer,
        operator,
      });

      copyOfFormsValues[targetFormIndex] = targetForm;
      setComponentScopeFilters({
        ...componentScopeFilters,
        forms: copyOfFormsValues,
      });
      return;
    }

    //  else: update the values only
    targetForm.fields[targetFieldIndex] = {
      id: targetForm.fields[targetFieldIndex]?.id,
      answer,
      operator,
    };
    copyOfFormsValues[targetFormIndex] = targetForm;
    setComponentScopeFilters({
      ...componentScopeFilters,
      forms: copyOfFormsValues,
    });
    return;
  };

  const getTargetFieldValue = (formId: number, fieldId: number) => {
    if (!componentScopeFilters?.forms) {
      return undefined;
    }

    const copyOfFormsValues = componentScopeFilters.forms;
    const targetForm = copyOfFormsValues?.find(f => f.id === formId);

    if (!targetForm) {
      return undefined;
    }

    const targetField = targetForm?.fields.find(f => f.id === fieldId);

    if (targetField) {
      return targetField;
    } else {
      return undefined;
    }
  };

  if (!componentScopeFilters) return <CenteredSpinner />;

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
      size={'lg'}
    >
      <DrawerContent>
        <DrawerHeader>
          <HStack align="center">
            <HStack>
              <Box
                borderRadius="md"
                boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                border="1px"
                borderColor="custom_gray.4"
                px="2"
                py="1"
              >
                <Icon as={FiltersIcon} />
              </Box>
              <Text fontWeight="semibold" fontSize="md">
                Filters
              </Text>
            </HStack>
            <DrawerCloseButton />
          </HStack>
        </DrawerHeader>
        <Divider />

        <DrawerBody>
          {/*  */}
          <Box key={'projectId'} mb="4">
            <Text fontWeight="medium" fontSize="sm">
              Project
            </Text>

            <FormControl flexBasis="50%" mt="2">
              <Select
                onChange={e =>
                  setComponentScopeFilters({
                    ...componentScopeFilters,
                    projectId: Number(e.target.value),
                  })
                }
              >
                <option value={undefined}>All</option>

                {projectsData?.data?.content.map(project => (
                  <option key={project.id} value={project.id}>
                    {project.projectName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
          {/*  */}
          {phasesData?.data && phasesData?.data?.content.length > 0 && (
            <Box key={'phaseId'} mb="4">
              <Text fontWeight="medium" fontSize="sm">
                Phase
              </Text>

              <FormControl flexBasis="50%" mt="2">
                <Select
                  onChange={e =>
                    setComponentScopeFilters({
                      ...componentScopeFilters,
                      phaseId: [Number(e.target.value)],
                    })
                  }
                >
                  <option value={undefined}>All</option>

                  {phasesData?.data?.content.map(phase => (
                    <option key={phase.id} value={phase.id}>
                      {phase.phaseName}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
          {/*  */}
          {rolesData?.data && rolesData?.data?.content.length > 0 && (
            <Box key={'roleAssignee'} mb="4">
              <Text fontWeight="medium" fontSize="sm">
                Assigned Roles
              </Text>

              <FormControl flexBasis="50%" mt="2">
                <MultiSelect
                  options={rolesData?.data?.content.map(role => ({
                    label: role.name,
                    value: `${role.id}`,
                  }))}
                  value={componentScopeFilters?.roleAssignee || []}
                  onChange={changes =>
                    setComponentScopeFilters({
                      ...componentScopeFilters,
                      roleAssignee: changes as Option[],
                    })
                  }
                />
              </FormControl>
            </Box>
          )}
          {/*  */}
          {usersData?.data && usersData?.data?.content.length > 0 && (
            <Box key={'userAssignee'} mb="4">
              <Text fontWeight="medium" fontSize="sm">
                Assigned Users
              </Text>

              <FormControl flexBasis="50%" mt="2">
                <MultiSelect
                  options={usersData?.data?.content.map(user => ({
                    label: `${user.firstName} ${user.lastName}`,
                    value: `${user.id}`,
                  }))}
                  value={componentScopeFilters?.userAssignee || []}
                  onChange={changes =>
                    setComponentScopeFilters({
                      ...componentScopeFilters,
                      userAssignee: changes as Option[],
                    })
                  }
                />
              </FormControl>
            </Box>
          )}
          {/*  */}
          <Box key={'deadline'} mb="4">
            <Text fontWeight="medium" fontSize="sm">
              Deadline
            </Text>

            <FormControl flexBasis="50%" mt="2">
              <Input
                type="date"
                value={componentScopeFilters?.deadline || undefined}
                onChange={e =>
                  setComponentScopeFilters({
                    ...componentScopeFilters,
                    deadline: e.target.value,
                  })
                }
              />
            </FormControl>
          </Box>
          {/*  */}
          <Box>
            <HStack mt="12" mb="1">
              <Box
                borderRadius="md"
                boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                border="1px"
                borderColor="custom_gray.4"
                px="2"
                py="1"
              >
                <Icon as={AdvancedFilter} />
              </Box>
              <Text fontWeight="semibold" fontSize="md">
                Advanced Form Filters
              </Text>
            </HStack>

            {formsData?.data && formsData?.data.length > 0 && (
              <Accordion allowMultiple sx={{ mt: '5' }}>
                {formsData?.data.map(form => (
                  <AccordionItem
                    key={form.name}
                    sx={{
                      mb: '4',
                      border: 'none',
                      boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
                    }}
                  >
                    <h2>
                      <AccordionButton
                        sx={{ bg: 'custom_gray.4', borderRadius: '8px' }}
                      >
                        <Box as="span" flex="1" textAlign="left">
                          {form.name}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel>
                      {form.fields.map(field => {
                        if (
                          field.type === FormFieldTypes.date ||
                          field.type === FormFieldTypes.text ||
                          field.type === FormFieldTypes.longText
                        ) {
                          return (
                            <Box key={field.id} mb="4">
                              <Text fontWeight="medium" fontSize="sm">
                                {field.title}
                              </Text>

                              <FormControl flexBasis="50%" mt="2">
                                <Input
                                  key={field.id}
                                  type={
                                    field.type === FormFieldTypes.date
                                      ? 'date'
                                      : 'text'
                                  }
                                  value={
                                    getTargetFieldValue(
                                      form.id as number,
                                      field.id as number
                                    )?.answer || undefined
                                  }
                                  onChange={e =>
                                    setFieldValue(
                                      form.id as number,
                                      field.id as number,
                                      e.target.value,
                                      FiltersOperation.Equal
                                    )
                                  }
                                />
                              </FormControl>
                            </Box>
                          );
                        }

                        if (field.type === FormFieldTypes.number) {
                          return (
                            <Box key={field.id} mb="4">
                              <Text fontWeight="medium" fontSize="sm">
                                {field.title}
                              </Text>
                              <HStack>
                                <FormControl flexBasis="35%" mt="2">
                                  <Select
                                    onChange={e =>
                                      setFieldValue(
                                        form.id as number,
                                        field.id as number,
                                        getTargetFieldValue(
                                          form.id as number,
                                          field.id as number
                                        )?.answer,
                                        e.target.value
                                      )
                                    }
                                    value={
                                      getTargetFieldValue(
                                        form.id as number,
                                        field.id as number
                                      )?.operator
                                    }
                                  >
                                    <option />
                                    {getConditionOperator(field).map(value => (
                                      <option value={value} key={value}>
                                        {value}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>
                                <FormControl flexBasis="65%" mt="2">
                                  <Input
                                    key={field.id}
                                    type="number"
                                    value={
                                      getTargetFieldValue(
                                        form.id as number,
                                        field.id as number
                                      )?.answer || undefined
                                    }
                                    onChange={e =>
                                      setFieldValue(
                                        form.id as number,
                                        field.id as number,
                                        e.target.value,
                                        getTargetFieldValue(
                                          form.id as number,
                                          field.id as number
                                        )?.operator
                                      )
                                    }
                                  />
                                </FormControl>
                              </HStack>
                            </Box>
                          );
                        }

                        if (field.type === FormFieldTypes.singleSelection) {
                          return (
                            <Box key={field.id} mb="4">
                              <Text fontWeight="medium" fontSize="sm">
                                {field.title}
                              </Text>

                              <FormControl flexBasis="50%" mt="2">
                                <Select
                                  value={
                                    getTargetFieldValue(
                                      form.id as number,
                                      field.id as number
                                    )?.answer || undefined
                                  }
                                  onChange={e =>
                                    setFieldValue(
                                      form.id as number,
                                      field.id as number,
                                      e.target.value,
                                      FiltersOperation.Equal
                                    )
                                  }
                                >
                                  <option value={undefined}>All</option>

                                  {field.options?.map(option => (
                                    <option
                                      key={option.title}
                                      value={option.title}
                                    >
                                      {option.title}
                                    </option>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          );
                        }

                        if (field.type === FormFieldTypes.multipleSelection) {
                          return (
                            <Box key={field.id} mb="4">
                              <Text fontWeight="medium" fontSize="sm">
                                {field.title}
                              </Text>

                              <FormControl flexBasis="50%" mt="2">
                                <MultiSelect
                                  options={field.options?.map(option => ({
                                    label: option.title,
                                    value: option.title,
                                  }))}
                                  value={
                                    getTargetFieldValue(
                                      form.id as number,
                                      field.id as number
                                    )?.answer || undefined
                                  }
                                  onChange={changes =>
                                    setFieldValue(
                                      form.id as number,
                                      field.id as number,
                                      changes,
                                      FiltersOperation.Equal
                                    )
                                  }
                                />
                              </FormControl>
                            </Box>
                          );
                        }
                      })}
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </Box>
        </DrawerBody>

        <DrawerFooter>
          <Box
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button
              variant="outline"
              mr={3}
              onClick={() => {
                setComponentScopeFilters(filters);
                onClose();
              }}
            >
              Cancel
            </Button>
            <Box>
              <Button
                style={{
                  background: 'rgba(236 , 94, 42, 0.08)',
                  border: '1px solid #EC5E2A',
                  color: '#EC5E2A',
                }}
                mr={3}
                onClick={() => {
                  // eslint-disable-next-line prefer-const
                  let parentScopeFilters = JSON.parse(
                    JSON.stringify(componentScopeFilters)
                  );
                  parentScopeFilters.roleAssignee =
                    componentScopeFilters.roleAssignee?.map(role =>
                      Number(role.value)
                    );
                  parentScopeFilters.userAssignee =
                    componentScopeFilters.userAssignee?.map(user =>
                      Number(user.value)
                    );

                  if (parentScopeFilters.userAssignee?.length === 0) {
                    delete parentScopeFilters.userAssignee;
                  }

                  if (parentScopeFilters.roleAssignee?.length === 0) {
                    delete parentScopeFilters.roleAssignee;
                  }

                  if (
                    parentScopeFilters.forms &&
                    parentScopeFilters.forms.length > 0
                  ) {
                    parentScopeFilters.forms.forEach((form, formIndex) =>
                      form.fields.forEach((field, fieldIndex) => {
                        parentScopeFilters.forms[formIndex].fields[
                          fieldIndex
                        ].operator = convertTitleCaseToConditionsEnum(
                          field.operator
                        );

                        if (Array.isArray(field.answer)) {
                          parentScopeFilters.forms[formIndex].fields[
                            fieldIndex
                          ].answer = field.answer.map(i => i.value).join(', ');
                        }
                      })
                    );
                  } else {
                    parentScopeFilters.forms = undefined;
                  }

                  setFilters(parentScopeFilters);
                  saveFilters(parentScopeFilters);
                  onClose();
                }}
              >
                Save & Apply Filters
              </Button>

              <Button
                type="submit"
                bg="custom_orange.2"
                _hover={{ bg: 'custom_orange.2' }}
                color="white"
                onClick={() => {
                  // eslint-disable-next-line prefer-const
                  let parentScopeFilters = JSON.parse(
                    JSON.stringify(componentScopeFilters)
                  );
                  parentScopeFilters.roleAssignee =
                    componentScopeFilters.roleAssignee?.map(role =>
                      Number(role.value)
                    );
                  parentScopeFilters.userAssignee =
                    componentScopeFilters.userAssignee?.map(user =>
                      Number(user.value)
                    );

                  if (parentScopeFilters.userAssignee?.length === 0) {
                    delete parentScopeFilters.userAssignee;
                  }

                  if (parentScopeFilters.roleAssignee?.length === 0) {
                    delete parentScopeFilters.roleAssignee;
                  }

                  if (
                    parentScopeFilters.forms &&
                    parentScopeFilters.forms.length > 0
                  ) {
                    parentScopeFilters.forms.forEach((form, formIndex) =>
                      form.fields.forEach((field, fieldIndex) => {
                        parentScopeFilters.forms[formIndex].fields[
                          fieldIndex
                        ].operator = convertTitleCaseToConditionsEnum(
                          field.operator
                        );

                        if (Array.isArray(field.answer)) {
                          parentScopeFilters.forms[formIndex].fields[
                            fieldIndex
                          ].answer = field.answer.map(i => i.value).join(', ');
                        }
                      })
                    );
                  } else {
                    parentScopeFilters.forms = undefined;
                  }

                  setFilters(parentScopeFilters);
                  onClose();
                }}
              >
                Apply Filters
              </Button>
            </Box>
          </Box>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
